import {
  COMMUNES_FETCHING,
  FETCH_COMMUNES,
  FILTER_COMMUNES_BY_PATTERN,
  FIND_COMMUNE,
} from "../actions/types";

const initialState = {
  items: [],
  loadedItems: [],
  filteredItems: [],
  found: null,
  isFetching: false,
  loader: "",
  limit: 0,
  offset: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case COMMUNES_FETCHING:
      return { ...state, isFetching: true };

    case FETCH_COMMUNES:
      return {
        ...state,
        items: action.payload.items,
        filteredItems: action.payload.loaded,
        loadedItems: action.payload.loaded,
        loader: action.payload.loader,
        isFetching: false,
      };

    case FIND_COMMUNE:
      return {
        ...state,
        found: action.payload,
      };

    default:
      return state;
  }
}
